// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_Nob","cls2":"ImpactHubModal-cls2_UhY ImpactHubModal-cls1_Nob"};